/**
 * Legal & Policy Service
 * 이용약관, 개인정보처리방침, 금융 면책 고지 및 통신판매업자 정보 조회를 위한 중앙 서비스 (SSOT)
 */

export interface PolicyDocument {
  id: string;
  type: 'TERMS_OF_SERVICE' | 'PRIVACY_POLICY' | 'FINANCIAL_DISCLAIMER';
  version: string;
  title: string;
  content: string;
  is_mandatory: number;
  effective_date: string;
}

export interface CompanyLegalInfo {
  companyName: string;
  brandName: string;
  representative: string;
  businessRegistrationNumber: string;
  mailOrderSalesRegistrationNumber: string;
  address: string;
  email: string;
  phone: string;
  hostingProvider: string;
  cpo: {
    name: string;
    email: string;
    phone: string;
  };
  financialDisclaimerSummary: string;
  version?: string;
  effectiveDate?: string;
}

export async function fetchPolicyDocument(type: 'TERMS_OF_SERVICE' | 'PRIVACY_POLICY' | 'FINANCIAL_DISCLAIMER'): Promise<PolicyDocument | null> {
  try {
    const res = await fetch(`/api/legal/policies?type=${type}`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' }
    });
    if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
    const json = (await res.json()) as any;
    return json.data || null;
  } catch (error) {
    console.warn('[legalApi] Failed to fetch policy document:', error);
    return null;
  }
}

export async function fetchCompanyInfo(): Promise<CompanyLegalInfo | null> {
  try {
    const res = await fetch('/api/legal/company-info', {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' }
    });
    if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
    const json = (await res.json()) as any;
    return json.data || null;
  } catch (error) {
    console.warn('[legalApi] Failed to fetch company info:', error);
    return null;
  }
}

export async function submitPolicyAgreements(
  token: string,
  agreements: Array<{ type: string; version: string; agreed: boolean }>
): Promise<boolean> {
  try {
    const res = await fetch('/api/legal/policies', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify({ agreements })
    });
    return res.ok;
  } catch (error) {
    console.error('[legalApi] Failed to submit policy agreements:', error);
    return false;
  }
}

export async function fetchUserAgreementsStatus(token: string): Promise<{
  isFullyCompliant: boolean;
  agreements: Record<string, { version: string; agreed: boolean; agreed_at: string }>;
} | null> {
  try {
    const res = await fetch('/api/legal/agreements', {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
    if (!res.ok) return null;
    const json = (await res.json()) as any;
    return json.data || null;
  } catch (error) {
    console.warn('[legalApi] Failed to fetch agreements status:', error);
    return null;
  }
}
